var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "report-agent-performance" } }, [
    _c("div", { staticClass: "overall-content" }, [
      _c(
        "div",
        { staticClass: "chart-container" },
        [
          _c(
            "div",
            { staticClass: "chart-section" },
            [
              _c(
                "div",
                { staticClass: "title" },
                [
                  _c("ChartDoddleIcon"),
                  _vm._v(" "),
                  _c("h2", [
                    _vm._v(_vm._s(_vm.$t("report.chatResolveTimeByAgent"))),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c("ResolveTimeByUser", {
                attrs: {
                  title: _vm.$t("report.chatResolveTimeByAgent"),
                  filters: _vm.filters,
                  loading: _vm.loading,
                  data: _vm.data.resolveTime,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("a-divider"),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "chart-section" },
            [
              _c(
                "div",
                { staticClass: "title" },
                [
                  _c("ChartDoddleIcon"),
                  _vm._v(" "),
                  _c("h2", [
                    _vm._v(_vm._s(_vm.$t("report.firstAnswerByAgent"))),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c("FirstInteractionTimeByUser", {
                attrs: {
                  title: _vm.$t("report.firstAnswerByAgent"),
                  filters: _vm.filters,
                  loading: _vm.loading,
                  data: _vm.data.firstInteraction,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }